import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpAi'

export const languagesList = (params = '') => Http.get(`/admin/language-models${serialize(params)}`)
export const languageCreate = (params = '') => Http.post('/admin/language-models', params)
export const languageByID = (params = '') => Http.get(`/admin/language-models${params}`)
export const languageUpdate = (params = '') => Http.put(`/admin/language-models/${params.id}`, params)
export const languageDestroy = (params = '') => Http.delete(`/admin/language-models/${params.id}`)
